export default __webpack_public_path__ + "static/hfeatures-2-1f087fb2982bd9e8040bbd59edab91e8.png";